module.exports = __webpack_public_path__ + "static/media/shape-open.03f5ede8.svg";